// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HEfl","content":"styles_content__TY1EO","tableWrap":"styles_tableWrap__3iq7W"};